import util from "@/mixins/util";

export default {
    methods: {
        getCountry(id=null) {
            let params = {};
            if(!util.isEmpty(id)) {
                params.id = id;
            }
            return this.$api.$config.getCountry(params).then(res => res.Data.Result).then(res => {
                if(res.Info.type != 1 || util.isEmpty(res.List)) {
                    return [];
                }
                return res.List;
            })
        },
        getArea(id=null) {
            let params = {};
            if(!util.isEmpty(id)) {
                params.id = id;
            }
            return this.$api.$config.getGuArea(params).then(res => res.Data.Result).then(res => {
                if(res.Info.type != 1 || util.isEmpty(res.List)) {
                    return [];
                }
                return res.List;
            })
        },
        getLanguage(id=null) {
            let params = {};
            if(!util.isEmpty(id)) {
                params.id = id;
            }
            return this.$api.$config.getLanguage(params).then(res => res.Data.Result).then(res => {
                if(res.Info.type != 1 || util.isEmpty(res.List)) {
                    return [];
                }
                return res.List;
            })
        }
    },
}
